import { Component, OnInit, ViewChild } from '@angular/core';
import { NuevoPasswordViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';
import { UsuarioService } from '../../services/usuario.service';

import { Router, ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-nuevo-password',
  templateUrl: './nuevo-password.component.html',
  styleUrls: ['./nuevo-password.component.scss']
})
export class NuevoPasswordComponent implements OnInit {

  usuario: NuevoPasswordViewModel = new NuevoPasswordViewModel();

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  private sub: any;
  private subq: any;

  errores: Array<string> = [];

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private route: ActivatedRoute, private usuarioService: UsuarioService, private router: Router) {
    
    this.sub = this.route.params.subscribe(params => {
      this.usuario.usuarioId = params['id'];      
    });
    this.subq = this.route.queryParams.subscribe(params => {
      this.usuario.token = params['token'];      
    });
  }

  ngOnInit() {
  }

modificar(){    
    this.alert.visible = false;        
    this.usuarioService.modificarPassword(this.usuario)
      .map(result => {
        this.alert.visible = true;
        this.alert.closed = false;
        this.alert.titulo = "Modificar contraseña";
        if (result.status == 201) {
          this.router.navigate(['login'])
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."
        }        
        this.alertComponent.setType(this.alert.tipo);        
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();                
        this.alert.visible = true;
        this.alert.closed = false;
        this.alert.titulo = "Modificar contraseña";
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."        
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/usuarios/nuevo-password/nuevo-password.component.ts